export const styles = {
  gridRow: {
    display: 'flex',
  },
};
